import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Output, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { ApiErrorCodes } from '../../../../core/enums/ErrorCodes';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { FormControlComponent } from '../../../../shared/components/form-control/form-control.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { CartService } from '../../core/services/CartService';

@Component({
  selector: 'app-discount-code-input-modal',
  standalone: true,
  imports: [
    TranslatePipe,
    ModalComponent,
    FormControlComponent,
    FormsModule
  ],
  templateUrl: './discount-code-input-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiscountCodeInputModalComponent extends BaseModalComponent {

  @ViewChild('codeInput') public codeInput: ElementRef<HTMLInputElement>;
  @Output() public discountApplied = new EventEmitter<void>();

  private readonly _cartService = inject(CartService);

  public readonly code = signal('');
  public readonly isLoading = signal(false);

  public override open(val?: null): void {
    this.code.set('');
    this.isLoading.set(false);
    super.open(val);
    setTimeout(() => this.codeInput?.nativeElement?.focus());
  }

  public onSubmit(): void {
    const normalizedCode = this.code().trim().toUpperCase();

    if (!normalizedCode || this.isLoading()) {
      return;
    }

    this.code.set(normalizedCode);
    this.isLoading.set(true);

    this._cartService.applyDiscountCodeToCart(normalizedCode)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: (res) => {
          if (!(res.message in ApiErrorCodes)) {
            this.close();
            this.discountApplied.emit();
          }
        },
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`apply-discount-code/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
